import styled from '@emotion/styled';
import { type TFunction } from 'react-i18next';

import type { Step } from 'pages/AutomationEngine/types/automation';

import DraggableStepCard from '__pages/AutomationEngine/Engine/Steps/DraggableStepCard';
import { VariableSource } from '__pages/AutomationEngine/dialogs/VariableWizard/types';
import { HistoryVariableValue } from '__pages/AutomationEngine/HistoryFrameWork';
import { getDescriptionValue } from './getDescriptionValue';
import { VariableDropzoneCard } from './VariableDropzoneCard';
import type { CardProps } from '../../types';
import { useIsVariableDropZone } from './useIsVariableDropZone';

const Container = styled.span`
  font-size: 1.4em;
  * {
    font-size: 1em;
  }
`;

export const content = ({ step }: { step: Step }) =>
  step.history?.[0]?.detailedLog ? (
    <HistoryVariableValue detailedLog={step.history[0].detailedLog} />
  ) : (
    <Container dangerouslySetInnerHTML={{ __html: step.description }} />
  );

type GetDescription = {
  step: VariableSource;
  t: TFunction;
};

export const getDescription = ({ step, t }: GetDescription) => {
  const { details } = step;
  const { descriptionValue, descriptionPlural } = getDescriptionValue({
    details,
    t,
  });
  return t(`%{variableName}% = %{descriptionValue}%%{descriptionPlural}%`, {
    interpolation: { prefix: '%{', suffix: '}%' },
    variableName: details.variable.name,
    descriptionValue,
    descriptionPlural,
  });
};

export default function VariableInitializationCard({
  step,
  ...others
}: CardProps) {
  const isVariableDropZone = useIsVariableDropZone(step);

  const dropZoneProps = isVariableDropZone
    ? {
        addMenu: false,
        onSelectMenu: null,
        onStart: null,
        onStop: null,
      }
    : {};

  return (
    <DraggableStepCard
      {...others}
      step={step}
      {...dropZoneProps}
      leading={isVariableDropZone ? <VariableDropzoneCard step={step} /> : null}
    >
      {content({ step })}
    </DraggableStepCard>
  );
}
